// import styles from "./purchase.module.css";
// import React, { useState, useEffect } from 'react';

import React from 'react'

export default function Index() {
  return (
    <>
    </>
  )
}











// function index() {
 



//     return (
//         <div className={styles.purchasemainBG}>

//             <div className={styles.purchasemainTop}>

//                 <div className={styles.purchasemainTop_left}>
//                     <div className={styles.purchasemainTop_leftCon}>
//                         <span>
//                             <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/divine_sign_up_logo.webp"></img>
//                         </span>
//                         <div className={styles.purchasemainTop_logoText}>
//                             <h1 data-text="SCHOOL OF THE DIVINE">SCHOOL OF THE DIVINE</h1>
//                             <h1 data-text="INFINITE BEING">INFINITE BEING</h1>
//                         </div>
//                     </div>

//                 </div>


//                 <div className={styles.purchasemainTop_right}>

//                     <div className={styles.purchasemainTop_rightBG}>

//                         <div className={styles.purchasemainTop_rightIMG}>
//                             <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home-page-as-image1.jpg'></img>

//                         </div>

//                         <div className={styles.purchasemainTop_rightText}>

//                             <h2>NAME: Lorem Ipsum is simply dummy text </h2>
//                             <p>Lorem Ipsum is simply dummy text of the printing and typesetting the industry simply dummy text Lorem Ipsum is simply dummy text.</p>



//                             <div className={styles.purchasemainTop_rightTextBottom}>
//                                 <label>FREQUENCY: SINGLE</label>
//                                 <div className={styles.purchasemainTop_rightTextBottomCon}>
//                                     <h3>PRICE:</h3>
//                                     <strong>$150</strong>
//                                     <button>PURCHASE</button>
//                                 </div>
//                             </div>

//                         </div>



//                     </div>

//                 </div>

//             </div>

//             <div className={styles.purchasemainContain}>
//                 <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, <span>remaining essentially unchanged. Lorem Ipsum has been the industry's</span> standard dummy text ever since the 1500s, when an unknown printer <br /> <br /> It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum, and more recently with desktop publishing software like.


//                 </p>

//             </div>

//             <div className={styles.purchasemainBottom}>

//                 <div className={styles.purchasemainBottom_left}>
//                     <h2>WEBINER:</h2>
//                     <ul>
//                         <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </li>

//                         <li>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </li>

//                         <li>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</li>
//                     </ul>


//                 </div>



//             </div>

//         </div>
//     )
// }

// export default index
